export default {
  toolbar: {
    margin: 'auto auto 10px auto'
  },
  img: {
    width: 120,
    maxWidth: 120,
    height: 120,
    maxHeight: 120,
    margin: 'auto auto 10px auto'
  },
  h3: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginTop: 5
  },
  card: {
    border: '1px solid #CCC',
    borderRadius: 3,
    margin: '1%',
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 23%',
    minWidth: 250,
    maxWidth: '23%'
  }
};



// WEBPACK FOOTER //
// ./src/browser/Feature/components/team_section/styles.js